import { render, staticRenderFns } from "./rename-document-modal.vue?vue&type=template&id=1e859686"
import script from "./rename-document-modal.vue?vue&type=script&lang=js"
export * from "./rename-document-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports